import { HttpErrorHandlerFn } from '@web/common';

export const UnknownErrorMessageHandler: HttpErrorHandlerFn = () => {
  return ['Wystąpił nieznany błąd. Proszę skontaktować się z Administratorem.'];
};
